import request from '@/lib/request/';

const baseUri = '/mapping/';

/**
 * @returns {Promise}
 */
export function get(id, params) {
  return request({
    url: baseUri + id,
    method: 'get',
    params,
  });
}
